<template lang="pug">
  r-table(
    no-data-text='Sin resultados.'
    no-detail
    no-remove
    no-search
    ref='table'
    v-bind='tableProps'
    )
    template( slot='items' )
      v-btn( color='success' @click='submitExcel' ) excel  &nbsp;
        v-icon cloud_download
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import SlGroundSellerSaleCommissionFilters from '@/views/Sale/SlGroundSellerSaleCommission/SlGroundSellerSaleCommissionFilters'
  import SlGroundSellerSaleCommissionHeaders from '@/views/Sale/SlGroundSellerSaleCommission/SlGroundSellerSaleCommissionHeaders'
  import SlGroundSellerSaleCommissionModel from '@/models/Sale/SlGroundSellerSaleCommission'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          filters: SlGroundSellerSaleCommissionFilters,
          headers: SlGroundSellerSaleCommissionHeaders,
          service: SlGroundSellerSaleCommissionModel,
        }
      }
    },
    methods: {
      submitExcel() {
        return this.toExcel(new SlGroundSellerSaleCommissionModel({ id: 'excel' }))
      },
      toExcel(model) {
        return model
          .excel('', { filter: this.$refs.table.filter })
          .then(model.showFile('REPORTE_VENDEDORES_TERRENO', 'xlsx'))
      },
    },
    created() {
      this.setTitle('Reporte de vendedores en terreno')
    },
  }
</script>